import React from 'react';
import './pages.style.css';

const About = () => {
    return (
        <div className='about-container'>
            <h1>About Us</h1>
            <p>We are a new millenuim bar, we offer various types of drinks ranging from non-alcoholic to alcoholic all at an affordable rate.
                And our services are top notch. We guarantee that a visit to our bar will definitely keep you coming back for more.
 </p>
 <h5>tel: <span>555 555 555</span></h5>
 <h5>email: <span>snazzybar@email.com</span></h5>
 <h5>address: <span>5123, snazzybar street, Utopia United</span></h5>

        </div>
    )
}

export default About
